import { useEffect, useState } from 'react';

/**
 * Resolves 'light' | 'dark' from the OS setting, and keeps following it.
 *
 * PRE-0 locked Connect to shipping both themes with the SYSTEM choosing, and no
 * in-app toggle. tokens.css already honours prefers-color-scheme for our own
 * custom properties, but the CometChat UIKit is driven by a `data-theme`
 * attribute, which App.tsx previously hard-coded to 'dark'. That pinned the
 * whole UIKit dark no matter what the OS said, so the light theme could never
 * appear on web however correct the tokens were.
 */
export function useSystemTheme(): 'light' | 'dark' {
  const query = '(prefers-color-scheme: dark)';
  const [theme, setTheme] = useState<'light' | 'dark'>(() =>
    typeof window !== 'undefined' && window.matchMedia?.(query).matches
      ? 'dark'
      : 'light',
  );

  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const onChange = (e: MediaQueryListEvent) =>
      setTheme(e.matches ? 'dark' : 'light');
    // addEventListener is unavailable on Safari < 14's MediaQueryList.
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return theme;
}
